import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceKeywordsPipeModule } from 'projects/common/pipes/replace-keywords.module';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { EvaMessageComponent } from './eva-message.component';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        EvaButtonModule,
        ReplaceKeywordsPipeModule
    ],
    exports: [
        EvaMessageComponent
    ],
    declarations: [
        EvaMessageComponent
    ],
    providers: [
    ],
})
export class EvaMessageModule { }
